import {
  filterFlashesForDisplay,
  flashAgeSec,
  flashBoltSizePx,
  flashOpacity,
  GLM_WINDOW_SEC,
} from "../data/glm.js";

const BOLT_PATH = [
  [7, 0],
  [0, 9],
  [5, 9],
  [4, 16],
  [12, 6],
  [7, 6],
];
const VB_W = 12;
const VB_H = 16;

export function boltSize(sizePx) {
  const height = Math.max(10, Math.min(14, sizePx));
  return { height, width: height * 0.75 };
}

export function lightningBoltSvg(sizePx) {
  const { width, height } = boltSize(sizePx);
  return `<svg xmlns="http://www.w3.org/2000/svg" class="lightning-bolt" width="${width}" height="${height}" viewBox="0 0 12 16" focusable="false" aria-hidden="true"><path d="M7 0 L0 9 H5 L4 16 L12 6 H7 Z" fill="#ffe566" stroke="#ffcc33" stroke-width="0.7" stroke-linejoin="round"/></svg>`;
}

export function flashesToDrawItems(flashes, frameMs, hideFuture, windowSec = GLM_WINDOW_SEC) {
  const visible = filterFlashesForDisplay(flashes || [], frameMs, {
    hideFuture: !!hideFuture,
    windowSec,
  });
  const items = [];
  for (const flash of visible) {
    const ageSec = flashAgeSec(flash, frameMs);
    const opacity = flashOpacity(ageSec, windowSec, { hideFuture: !!hideFuture });
    if (opacity <= 0) continue;
    items.push({
      flash,
      opacity,
      sizePx: flashBoltSizePx(ageSec, windowSec),
    });
  }
  return items;
}

export function drawBolt(ctx, x, y, sizePx, opacity) {
  const { width, height } = boltSize(sizePx);
  ctx.save();
  ctx.globalAlpha = opacity;
  ctx.translate(x, y);
  ctx.scale(width / VB_W, height / VB_H);
  ctx.translate(-VB_W / 2, -VB_H / 2);
  ctx.beginPath();
  ctx.moveTo(BOLT_PATH[0][0], BOLT_PATH[0][1]);
  for (let i = 1; i < BOLT_PATH.length; i++) {
    ctx.lineTo(BOLT_PATH[i][0], BOLT_PATH[i][1]);
  }
  ctx.closePath();
  ctx.fillStyle = "#ffe566";
  ctx.strokeStyle = "#ffcc33";
  ctx.lineJoin = "round";
  ctx.lineWidth = 0.7;
  ctx.fill();
  ctx.stroke();
  ctx.restore();
}
